import { useAppDispatch } from '../../../../store/store';
import { t } from '@hefe/i18n';
import React from 'react';
import CustomForm from '../../components/form/custom-form';
import { ModalsSlice, TablesSlice } from '@hefe/store';

interface TableColumnSelectionFormProps {
  tableName: string;
  keys: string[];
}

export default function TableColumnSelectionForm(
  props: TableColumnSelectionFormProps
) {
  const dispatch = useAppDispatch();

  const onSubmit = (values: any) => {
    // TODO Save keys in table setting
    const data = {
      name: values.name,
      keys: props.keys,
    };

    dispatch(
      TablesSlice.tablesActions.addPreset({
        tableName: props.tableName,
        name: values.name,
        keys: props.keys,
      })
    );

    dispatch(ModalsSlice.modalsActions.closeModal());
  };

  return (
    <CustomForm
      formId={`table-column-selection-form-${props.tableName}`}
      fields={[
        {
          label: t('name'),
          name: 'name',
          type: 'text',
          rules: [
            {
              required: true,
              message: 'name',
            },
          ],
        },
      ]}
      onSubmit={onSubmit}
    />
  );
}
